import axios from 'axios';
import config from '../appconfig/config.json';
import storage from '../factory/StorageFactory';

const getGovtApiUrl = () => {
    let govtApiUrl= '';
    switch (config.SERVER_STATUS) {
        case "DEV": govtApiUrl = config.GovtApi.DEV
        break;
        case "SIT": govtApiUrl = config.GovtApi.SIT 
        break;
        case "UAT": govtApiUrl = config.GovtApi.UAT 
        break;
        case "PROD": govtApiUrl = config.GovtApi.PROD 
        break;
        case "SIM": govtApiUrl = config.GovtApi.SIM 
        break;
        default:
        break;
    }
    return govtApiUrl;
}

const retrieveMyInfo = (stateId, code) => {
    let baseUrl = getGovtApiUrl();

    let url = baseUrl+"/GetSMEDigitalMyinfoData/"+stateId+"/"+code;
    let headerParams = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': storage.getToken()
        }
    }
    return axios.post(url,headerParams);
}

const retrievePerson = (stateId, code) => {
    let baseUrl = getGovtApiUrl();
    let url = baseUrl+"/GetSMEDigitalMyinfoData/"+stateId+"/"+code;
    let headerParams = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': storage.getToken()
        }
    }
    return axios.post(url,headerParams);
}

export default {
    retrieveMyInfo,
    retrievePerson
}